export const Pagination = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="7.5 3.5 10.5 17"
    >
      <path
        d="M8 20L16 12L8 4"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M17.5 4V20" stroke="currentColor" strokeLinecap="round" />
    </svg>
  )
}
